function createIframeHtml(data) {
  let docTypeTag = '';
  let docHead = data.headContent || '';
  let docBody = '';
  let blockCount = data.blockCount || '';

  if (data.docType) docTypeTag = `<!DOCTYPE ${data.docType}>`;
  docHead += `<style>.-normacs-client-doc-block-- {height: 100em !important}</style>`;
  for (let i = 0; i < blockCount; i++) {
    docBody += `<div class="-normacs-client-doc-block--" data-index="${i}"></div>`;
  }
  // Необходимо указывать полный URL на случай наличия тега <base> в загружаемом документе.
  let iframeStylesUrl = `${location.protocol}//${
    location.host
  }${__BASE_URL__}iframe-document-styles.css`;

  // TODO: Следует перенести этот файл в новый entry у webpack и забирать адрес из манифеста.
  // TEMP: временно отключили стили айфрейма  <link rel="stylesheet" href="${iframeStylesUrl}"/>

  const frameHtml = `${docTypeTag}
    <html ${data.htmlAttrs || ''}>
    <head>${docHead}</head>
    <body ${data.bodyAttrs || ''}>${docBody}</body>
    </html>`;

  return frameHtml;
}

function modifyClassifiers(list) {
  list.forEach(dbClassifiers => {
    dbClassifiers.classifiers.forEach(classifier => {
      classifier.paths.forEach(
        (path, index) => (classifier.paths[index] = path.reverse())
      );
    });
  });

  return list;
}

const DOC_CONFIG = {
  info: {
    apiMethod: 'getInfo',
    properties: [
      {
        property: 'currDocInfo',
        type: 'object'
      }
    ]
  },
  continuity: {
    apiMethod: 'getContinuity',
    properties: [
      {
        property: 'currDocContinuity',
        type: 'string',
        modifyFunc: res => (res.content ? res.content : '')
      }
    ]
  },
  annotation: {
    apiMethod: 'getAnnotation',
    properties: [
      {
        property: 'currDocAnnotation',
        type: 'string',
        modifyFunc: res => (res.content ? res.content : '')
      }
    ]
  },
  changes: {
    apiMethod: 'getChanges',
    properties: [
      {
        property: 'currDocChanges',
        type: 'array'
      }
    ]
  },
  classifiers: {
    apiMethod: 'getDocumentClassifiers',
    properties: [
      {
        property: 'currDocClassifiers',
        type: 'array',
        modifyFunc: modifyClassifiers
      }
    ]
  },
  scanContent: {
    apiMethod: 'getScanContents',
    properties: [
      {
        property: 'currDocScanContent',
        type: 'array'
      }
    ]
  },
  scanPages: {
    apiMethod: 'getScan',
    properties: [
      {
        property: 'currDocScanPages',
        type: 'array'
      }
    ]
  },
  textContent: {
    apiMethod: 'getTextContents',
    properties: [
      {
        property: 'currDocTextContent',
        type: 'array'
      }
    ]
  },
  textHtml: {
    apiMethod: 'getHead',
    properties: [
      {
        property: 'currDocTextHtml',
        type: 'string',
        modifyFunc: createIframeHtml
      },
      {
        property: 'currDocTextHeadData',
        type: 'object'
      }
    ]
  },
  textBlock: {
    apiMethod: 'getText',
    properties: [
      {
        property: 'currDocTextBlocks',
        type: 'array',
        isArray: true,
        modifyFunc: res => (res.content ? res.content : '')
      }
    ]
  },
  history: {
    apiMethod: 'getHistory',
    properties: [
      {
        property: 'currDocHistory',
        type: 'array'
      }
    ]
  },
  discussions: {
    apiMethod: 'getDiscussions',
    properties: [
      {
        property: 'currDocDiscussions',
        type: 'array'
      }
    ]
  },
  revisions: {
    apiMethod: 'getRevisions',
    properties: [
      {
        property: 'currDocRevisions',
        type: 'array'
      }
    ]
  },
  attachments: {
    apiMethod: 'getAttachments',
    properties: [
      {
        property: 'currDocAttachments',
        type: 'array'
      }
    ]
  },
};

export default DOC_CONFIG;
